import { registerNamespaces } from "@/lib/i18n/dictionary";

import enHome from "@/locales/en/home.json";
import enPricing from "@/locales/en/pricing.json";
import thHome from "@/locales/th/home.json";
import thPricing from "@/locales/th/pricing.json";

/**
 * The home route's copy. Kept out of `home.ts` so that Server Components can
 * register the same list without importing through that file's client
 * boundary — a Server Component reading a named export from a `"use client"`
 * module gets a client reference, not the object.
 */
registerNamespaces({
  en: { home: enHome, pricing: enPricing },
  th: { home: thHome, pricing: thPricing },
});
